import React from 'react';
import { ErrorPage } from 'components';

const NotFound = () => (
  <ErrorPage />
);

export default NotFound;
